export const MAKE_REQUEST = "MEETING_ROOM_MAKE_REQUEST";
export const FAIL_REQUEST = "MEETING_ROOM_FAIL_REQUEST";
export const GET_MEETING_ROOM_LIST = "GET_MEETING_ROOM_LIST";
export const GET_UNIT_LIST = "GET_UNIT_LIST";
